module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.children && item.children.length > 0) ? _c('router-link', {
      staticClass: "nav-item nav-dropdown",
      attrs: {
        "tag": "li",
        "to": item.path + '' + item.children[0].path,
        "disabled": ""
      }
    }, [_c('div', {
      staticClass: "nav-link nav-dropdown-toggle",
      on: {
        "click": _vm.handleClick
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon,
        "color": "white"
      }
    }), _vm._v("\n                " + _vm._s(item.name) + "\n            ")], 1), _vm._v(" "), _c('ul', {
      staticClass: "nav-dropdown-items"
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        staticClass: "nav-item",
        on: {
          "click": _vm.addActive
        }
      }, [_c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('Icon', {
        attrs: {
          "type": child.icon,
          "color": "white"
        }
      }), _vm._v("\n                        " + _vm._s(child.name) + "\n                    ")], 1)], 1) : _vm._e()
    }))]) : _vm._e(), _vm._v(" "), (!item.hidden && !item.children) ? _c('li', {
      staticClass: "nav-item"
    }, [_c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": item.path,
        "exact": ""
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon,
        "color": "white"
      }
    }), _vm._v("\n                " + _vm._s(item.name) + "\n            ")], 1)], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23da11b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarItem.vue
// module id = 100
// module chunks = 83